import { render } from "./CourseHoldersLine.vue?vue&type=template&id=4b8ff6cc&scoped=true"
import script from "./CourseHoldersLine.vue?vue&type=script&lang=js"
export * from "./CourseHoldersLine.vue?vue&type=script&lang=js"

import "./CourseHoldersLine.vue?vue&type=style&index=0&id=4b8ff6cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b8ff6cc"]])

export default __exports__